// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__WZ_M6","signatureButtonsRight":"ModalSign_signatureButtonsRight__Qs3jF"};